export default {
  type : 'molten.dataViewers.history.HistoryViewModel',
  options : {
    order : {
      type : 'molten.SortModel',
      fields : [
        {
          type : 'molten.SortFieldModel',
          attrName : 'station.history.time',
          order : 'asc',
          missing : '_last'
        }
      ]
    },
    range : {
      end : '2022-07-18T03:59:59.999Z',
      start : '2022-07-11T04:00:00.000Z'
    },
    density : 'sparse',
    perPage : 1000,
    condition : {
      type : 'condition.Filter',
      rootCondition : {
        type : 'condition.Logical',
        operator : 'and',
        conditions : [
          {
            type : 'condition.Attribute',
            attrName : 'station.history.imageName',
            comparator : {
              type : 'generic.Exists'
            },
            contextPath : 'target'
          }
        ]
      }
    },
    isForItem : false,
    queryModes : {
      all : true,
      selected : false,
      targeted : false
    }
  },
  allPages : true,
  breakpoints : [],
  dataViewers : [
    {
      id : '0JcnonO7bGvlThFvW4YoOq',
      type : 'ps.AnalyticsSupport',
      settings : {
        type : 'ps.Analytics'
      }
    }
  ],
  perPageEditable : true
}
